import axios from "../../../../utils/axios-private";

export const getListDocumentation = ({ pageNumber, pageSize, filter }) => {
  return {
    type: "GET_LIST_DOCUMENTATION",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/documentation?page-size=${pageSize}&page=${pageNumber}`;
      axios
        .get(url, { signal: controller.signal })
        .then((response) => {
          resolve({ response });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
